import { Purchase } from "@modules/purchase/warranty/types/Purchase";
import { LoadingSpinner, ModalProps, Modal } from "@talladega/components";
import { useTranslation } from "next-i18next";
import usePageInfoFromQuery from "@modules/query-string/hooks/usePageInfoFromQuery";
import useExtendedWarrantyAllRates from "@modules/purchase/warranty/hooks/useExtendedWarrantyAllRates";
import WarrantyGraphChart from "./WarrantyGraphChart";
import WarrantyComponent from "./WarrantyComponent";
import RemainingWarranty from "./RemainingWarranty";
import { RANGE_QUOTE_SEGMENT } from "../types/DealSegmentConstants";
import WarrantyBrochure from "./WarrantyBrochure";

type Props = {
  purchase: Purchase;
  showChart?: boolean;
} & Pick<ModalProps, "isOpen" | "onClose">;

const CoverageDetailsModal = ({
  purchase,
  isOpen,
  onClose,
  showChart,
}: Props) => {
  const { t } = useTranslation(["purchase"]);
  const { dealSegment } = usePageInfoFromQuery();

  const extDefaultRatesEnabled = dealSegment !== RANGE_QUOTE_SEGMENT;

  const {
    data: extWarrantyAllRates,
    isSuccess,
    isLoading,
  } = useExtendedWarrantyAllRates(
    extDefaultRatesEnabled ? purchase.id : undefined
  );

  const vehicleWarranty = extWarrantyAllRates?.vehicleWarranty;
  const isVehicleWarrantyFetched = !!vehicleWarranty;

  return (
    <Modal
      isOpen={isOpen}
      alignment="center"
      onClose={onClose}
      title={t("purchase:whats_covered")}
    >
      <LoadingSpinner isLoading={isLoading} isOverlay />
      {isSuccess && (
        <>
          {showChart && vehicleWarranty && (
            <>
              <div className="mx-auto text-center">
                <RemainingWarranty vehicleWarranty={vehicleWarranty} isModal />
              </div>
              <div className="w-full pb-8">
                <WarrantyGraphChart
                  vehicleWarranty={vehicleWarranty}
                  redraw={isVehicleWarrantyFetched}
                />
              </div>
            </>
          )}

          <div className="rounded-lg px-4 text-left">
            <WarrantyComponent
              extendedWarrantyDefaultRates={extWarrantyAllRates}
            />

            <WarrantyBrochure extWarrantyRates={extWarrantyAllRates} />
          </div>
        </>
      )}
    </Modal>
  );
};

export default CoverageDetailsModal;
